/* eslint-disable no-nested-ternary */
import { Button as MantineButton, createStyles } from '@mantine/core';
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron-down.svg';
import { getTypographyStyles } from '../../theme/themeConfig';

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '8px',
      border: `1px solid ${colors.primary.default}`,
      transition: 'all 0.2s ease',
      ...getTypographyStyles('heading_2xs_semibold'),
      '&:disabled': {
        backgroundColor: colors.disabled.muted,
        border: `1px solid ${colors.disabled.subtle}`,
        color: colors.fg.muted,
        '& path': {
          fill: colors.fg.muted,
        },
      },
      ':hover': {
        cursor: 'pointer',
        backgroundColor: `${theme.other.colors.primaryHover} !important`,
      },
    },
    buttonDisabled: {
      ':hover': {
        cursor: 'not-allowed',
        backgroundColor: theme.colors.grey[8],
      },
    },
  };
});

const Button = (props:any) => {
  const { classes } = useStyles();
  const {
    disabled, onClick, children, withoutIcon, variant, loading,
  } = props;
  return (
    <MantineButton
      type="button"
      disabled={disabled}
      className={`${classes.button} ${disabled ? classes.buttonDisabled : ''}`}
      onClick={onClick}
      variant={variant}
      {...props}
    >
      {children}
      {withoutIcon ? null : loading ? null : <ChevronIcon />}
    </MantineButton>
  );
};

export default Button;
